/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupslinkresethint3Inputs */

const en_groupslinkresethint3 = /** @type {(inputs: Groupslinkresethint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new link stops the old one. People already in stay in.`)
};

const de_groupslinkresethint3 = /** @type {(inputs: Groupslinkresethint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit einem neuen Link gilt der alte nicht mehr. Wer dabei ist, bleibt dabei.`)
};

/**
* | output |
* | --- |
* | "A new link stops the old one. People already in stay in." |
*
* @param {Groupslinkresethint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupslinkresethint3 = /** @type {((inputs?: Groupslinkresethint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupslinkresethint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupslinkresethint3(inputs)
	return de_groupslinkresethint3(inputs)
});
export { groupslinkresethint3 as "groupsLinkResetHint" }